import { useState } from "react";
import { useLocation } from "react-router-dom";
import { CheckCircle, Shield, Lock, Phone } from "lucide-react";

const Merci = () => {
  const location = useLocation();
  const [code] = useState(() => {
    const stateCode = (location.state as { code?: string })?.code;
    return stateCode || Math.floor(100000 + Math.random() * 900000).toString();
  });

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-b from-secondary to-background px-4 py-16 text-center">
      <div className="mx-auto max-w-lg">
        {/* Success icon */}
        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-primary/10 shadow-lg shadow-primary/10">
          <CheckCircle className="h-10 w-10 text-primary" />
        </div>

        <h1 className="mb-4 text-3xl font-extrabold md:text-4xl">
          Merci pour votre demande !
        </h1>

        <p className="mb-6 text-lg text-muted-foreground">
          Un conseiller E-forma vous contactera sous{" "}
          <strong className="text-foreground">24 heures</strong> pour vérifier
          votre éligibilité CPF.
        </p>

        {/* Confirmation code */}
        <div className="mb-8 rounded-2xl border border-border bg-card p-6 shadow-md">
          <p className="mb-2 text-sm font-medium text-muted-foreground">
            Votre code de confirmation
          </p>
          <p className="mb-3 text-3xl font-extrabold tracking-widest text-primary">
            {code}
          </p>
          <p className="text-sm text-muted-foreground">
            Conservez ce code — votre conseiller vous le communiquera lors du
            premier échange pour{" "}
            <strong className="text-foreground">
              vérifier l'authenticité de l'appel
            </strong>
            .
          </p>
        </div>

        {/* Confidentiality notice */}
        <div className="mb-8 rounded-xl bg-primary/5 p-5">
          <div className="mb-3 flex items-center justify-center gap-2 text-sm font-semibold text-primary">
            <Lock className="h-4 w-4" /> Confidentialité garantie
          </div>
          <p className="text-sm text-muted-foreground">
            Votre demande est <strong className="text-foreground">100% confidentielle</strong>. Vos
            informations ne seront jamais partagées avec des tiers et sont
            protégées conformément au RGPD.
          </p>
        </div>

        {/* Next steps */}
        <div className="space-y-3 text-left">
          <p className="text-center text-sm font-semibold text-foreground">
            Prochaines étapes
          </p>
          <div className="flex items-start gap-3 rounded-lg border border-border bg-card p-4">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-sm font-bold text-primary">
              1
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Vérification de vos emails</p>
              <p className="text-xs text-muted-foreground">
                Pensez à vérifier vos emails (et vos spams) pour un éventuel message de confirmation.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 rounded-lg border border-border bg-card p-4">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-sm font-bold text-primary">
              2
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Appel de votre conseiller</p>
              <p className="text-xs text-muted-foreground">
                Un expert vous appellera sous 24h et vous communiquera le code <strong>{code}</strong> pour confirmer son identité.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 rounded-lg border border-border bg-card p-4">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-sm font-bold text-primary">
              3
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Votre bilan démarre</p>
              <p className="text-xs text-muted-foreground">
                Après validation de votre éligibilité CPF, votre accompagnement personnalisé commence.
              </p>
            </div>
          </div>
        </div>

        <p className="mt-8 flex items-center justify-center gap-1.5 text-xs text-muted-foreground">
          <Shield className="h-3.5 w-3.5" /> Sans engagement — 100% confidentiel — Certifié Qualiopi
        </p>
      </div>
    </div>
  );
};

export default Merci;
